// courses/my-model
import { postData, postRequest} from 'src/services/RestApi';

export const apiCreate = async (values) => {
  const queryData = requestParams(values);
  return await postData(
    'api/course/create', queryData
  );
};

export const apiUpdate = async (values) => {
  const queryData = requestParams(values, true);
  return await postData(
    'api/course/update', queryData
  );
};

export const apiDelete = async (values) => {
  return await postData(
    'api/course/delete', {courseId: values.id},
  );
};

export const apiAssign = async (args, type) => {
  // console.log('Assign: ', type, ' = ', args);
  return await postRequest(
    'api/student/assign/course', { values: args.values }, { courseId: args.courseId }
  );
};

export const apiUnassign = async (args, type) => {
  // console.log('unAssign: ', type, ' = ', args);
  return await postRequest(
    'api/student/unassign/course', {}, { courseId: args.courseId, studentId: args.studentId }
  );

};

function requestParams(values, isUpdate = false) {
  const queryData = {};
  if (isUpdate) {
    queryData.courseId = values.id;
  }

  if (values.codeField) {
    queryData.code = values.codeField;
  }
  if (values.nameField) {
    queryData.name = values.nameField;
  }
  if (values.openingField) {
    queryData.openingDay = values.openingField;
  }
  if (values.closingField) {
    queryData.closingDay = values.closingField;
  }
  if (values.expireField) {
    queryData.expireDay = values.expireField;
  }
  // if (values.startField) {
  //   queryData.startDay = values.startField;
  // }
  if (values.statusField) {
    queryData.statusId = values.statusField.value;
  }

  return queryData;
}
